import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=71fb82e2&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadioButtons: require('/vercel/path0/components/forms/RadioButtons.vue').default,Select: require('/vercel/path0/components/forms/Select.vue').default,InputField: require('/vercel/path0/components/forms/InputField.vue').default,Checkbox: require('/vercel/path0/components/forms/Checkbox.vue').default})
